import {SafeView, TabsContainer, Tabs} from "@onemind-services-llc/ui-components";
import SubscriptionHeader from "./subscriptionHeader";
import tabList from "./subscriptionTabList";
import BreadCrumb from "../../../components/breadCrumb";

const SubscriptionDetails = () => {
  return (
    <SafeView>
      <BreadCrumb />
      <SubscriptionHeader />
      <TabsContainer>
        <Tabs tabList={tabList} />
      </TabsContainer>
    </SafeView>
  );
};

export default SubscriptionDetails;
